import { render, staticRenderFns } from "./QuoteDistribution.vue?vue&type=template&id=6a769f5e&"
import script from "./QuoteDistribution.vue?vue&type=script&lang=js&"
export * from "./QuoteDistribution.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDistribution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports